import React, { useRef, useState, useEffect } from "react";
// import "primereact/resources/primereact.min.css";
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";

// import { NavLink } from "react-router-dom";
import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// import { Button } from "primereact/button";
// import ButtonFeature from "../../features/Button.jsx";
import "primeicons/primeicons.css";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
// import { AiFillEye, AiFillDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
// import { TabView, TabPanel } from "primereact/tabview";
import { IoMdPaper } from "react-icons/io";
import instance from "../../api/api.js";
// import {Help} from "../../utils";
import { MenuPoint } from "../../shared/compoments";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { IoMdEye } from "react-icons/io";
import { MdEdit, MdOutlinePayment } from "react-icons/md";
import { statusConfig } from "../../utils";
import { styleIcone } from "../../shared";
import { AiOutlinePrinter } from "react-icons/ai";
import DatatableShared from "../../shared/compoments/DatatableShared";
import { useDispatch } from "react-redux";
import { showModal, addItemInDataPrint } from "../../store/slice/PrintSlice";
import { useParams } from "react-router-dom";

function DetailFactureByDetailUser() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const infoDataPrint = useSelector((state) => state.print.dataPrint);
  const OPTIONS = [
    {
      name: "Voir plus",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
      path: "/factures/",
    },
    {
      name: "Effecuter un paiement",
      icone: <MdOutlinePayment style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      // path: "/paiement-creation/5",
      methode: (idData) => {
        navigate(`/paiement-creation/${idData}`);
      },
    },
    {
      name: "Modifier",
      icone: <MdEdit style={styleIcone} />,
      isIdData: true,
      addMethodClick: false,
      path: "/factures/editer/",
      // methode: (idData) => {
      //   console.log(idData);
      // },
    },
    {
      name: "Imprimer",
      icone: <AiOutlinePrinter style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        const element = factures.find((item) => item.id === idData);
        console.log("element", element);
        dispatch(addItemInDataPrint(element));
        dispatch(showModal());
      },
    },
  ];

  const INFO_COLUMN_TABLE = [
    {
      field: "created_at",
      header: "Date d'emission",
      body: (rowData) => {
        return <p>{new Date(rowData.created_at).toLocaleDateString("fr")}</p>;
      },
    },
    {
      field: "reference",
      header: "Référence",
    },
    {
      field: "statut",
      header: "Statut",
      body: (rowData) => {
        return (
          <span
            className="badge text-dark p-3 rounded-5"
            style={{
              background: statusConfig[rowData.statut],
            }}>
            {rowData.statut}
          </span>
        );
      },
    },
    {
      field: "type",
      header: "Nature",
    },
    {
      field: "id",
      header: "Période",
      body: (rowData) => {
        return rowData.date_debut ? (
          <p className="d-flex justify-content-center align-items-center place-items-center gap-3 flex-wrap">
            <span>{new Date(rowData.date_debut).toLocaleDateString("fr")}</span>
            <span>au</span>
            <span>{new Date(rowData.date_fin).toLocaleDateString("fr")}</span>
          </p>
        ) : (
          <p>Néant</p>
        );
      },
    },
    {
      field: "id",
      header: "Actions",
      body: (rowData) => {
        return <MenuPoint optionMenu={OPTIONS} idData={rowData.id} />;
      },
    },
  ];

  const [factures, setFactures] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [facturesFilter, setFacturesFilter] = useState([]);
  const [verifIfIsClick, setVerifIfIsClick] = useState("Toutes");
  const [factureReferenceContract, setFactureReferenceContract] = useState("");

  const ITEMSFILTER = ["reference", "type", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    libelle: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tarif: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    duree: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const filterFactureByImpayer = (e) => {
    const value = e.target.value;
    const elemntsFilter = facturesFilter.filter(
      (item) => item.statut === value
    );
    setFactures(elemntsFilter);
    setVerifIfIsClick(value);
    // factures.filter((item) => item.statut === value)
    console.log({
      value: value,
      FACTURES: factures,
      VerifIfIsClick: verifIfIsClick,
    });
  };
  const filterFactureByPayer = (e) => {
    const value = e.target.value;
    // setFactures(factures => );
    const elemntsFilter = facturesFilter.filter(
      (item) => item.statut === value
    );
    setFactures(elemntsFilter);
    setVerifIfIsClick(value);
    console.log({
      value: value,
      FACTURES: factures,
      VerifIfIsClick: verifIfIsClick,
    });
  };
  const filterFactureByAll = (e) => {
    const value = e.target.value;

    const elemntsFilter = facturesFilter.filter(
      (item) => item.statut !== value
    );
    setFactures(elemntsFilter);
    setVerifIfIsClick(value);
    console.log({
      value: value,
      FACTURES: factures,
      VerifIfIsClick: verifIfIsClick,
    });
  };
  const getListOfFactures = async () => {
    try {
      const response = await instance.get("factures");
      console.log("response.data.data", response.data.data);
      const {
        contract: { reference },
      } = response.data?.data[0];
      const elemnts = response.data.data.filter(
        (item) => Number(item.contract.client_id) === Number(id)
      );
      // console.log(
      //   "getListOfFacturesBYID",
      //   response.data.data.filter(
      //     (item) =>
      //       Number(item.contract.client_id) === Number(id) &&
      //       item.statut === "impayer"
      //   )
      // );
      setFactures(elemnts);
      setFacturesFilter(elemnts);
      setFactureReferenceContract(reference);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getListOfFactures();
  }, []);
  return (
    <>
      <AllCompomentShared
        libelleHeaderComp={`Factures du contrat : ${factureReferenceContract}`}
        isReturn
        isBtnFilter
        btnFilterArray={[
          {
            libelle: "Toutes",
            methode: filterFactureByAll,
            isClickOn: verifIfIsClick,
          },
          {
            libelle: "impayer",
            methode: filterFactureByImpayer,
            isClickOn: verifIfIsClick,
          },
          {
            libelle: "payer",
            methode: filterFactureByPayer,
            isClickOn: verifIfIsClick,
          },
        ]}
        titleStatisticHeaderComp={"Nombre de factures"}
        nbreTotalStatistiqueComp={factures.length}
        SearchTableIsSearch={true}
        placeholderInputSearch={"Recherche"}
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
        iconeStatistiqueHeader={<IoMdPaper fontSize={"2em"} />}
        isLoading={isLoading}>
        <DatatableShared
          ITEMSFILTER={ITEMSFILTER}
          filters={filters}
          items={factures}
          dataInfoColumn={INFO_COLUMN_TABLE}
        />
      </AllCompomentShared>
    </>
  );
}

export default DetailFactureByDetailUser;
